import { PaymentPlanType } from 'QuoteApp/services/endpoints/GetPaymentDetails';

export const isInstallmentPlan = (paymentPlan: PaymentPlanType) =>
  paymentPlan.paymentFrequencyIdentifier === 'monthly' ||
  paymentPlan.paymentFrequencyIdentifier === 'semi_monthly' ||
  paymentPlan.paymentFrequencyIdentifier === 'bi_weekly' ||
  paymentPlan.paymentFrequencyIdentifier === 'weekly';

export const isPayInFullPlan = (paymentPlan: PaymentPlanType) =>
  paymentPlan.paymentFrequencyIdentifier === 'full_pay' ||
  paymentPlan.paymentFrequencyIdentifier === 'in_full';
